import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useApiContext from 'hooks/useApiContext';
import useRepo from 'hooks/useRepo';

interface UseCrmEventReturn {
  selectedEventId: number | null;
  setSelectedEventId: (id: number) => void;
  events: any[];
  eventsLoading: boolean;
}

export default function useCrmEvent(): UseCrmEventReturn {
  const [searchParams, setSearchParams] = useSearchParams();
  const { eventRepository } = useApiContext();
  const [initialized, setInitialized] = useState(false);

  const { response: events = [], loading: eventsLoading } = useRepo(
    async () => await eventRepository.getEvents(),
    []
  );

  const eventIdParam = searchParams.get('eventId');
  const selectedEventId = eventIdParam ? Number(eventIdParam) : null;

  useEffect(() => {
    if (!initialized && events.length > 0 && !selectedEventId) {
      setSearchParams(
        (prev) => {
          prev.set('eventId', String(events[0]?.id));
          return prev;
        },
        { replace: true }
      );
      setInitialized(true);
    }
  }, [events, initialized, selectedEventId]);

  const setSelectedEventId = useCallback(
    (id: number) => {
      setSearchParams(
        (prev) => {
          prev.set('eventId', String(id));
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return {
    selectedEventId,
    setSelectedEventId,
    events,
    eventsLoading,
  };
}
